import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CrmDashboard from "@/pages/admin/CrmDashboard";
import CrmCarriers from "@/pages/admin/CrmCarriers";
import CrmCarrierProfile from "@/pages/admin/CrmCarrierProfile";
import CrmLoads from "@/pages/admin/CrmLoads";
import CrmDocuments from "@/pages/admin/CrmDocuments";
import CrmFollowups from "@/pages/admin/CrmFollowups";
import CrmInvoices from "@/pages/admin/CrmInvoices";
import CrmInvoicePrint from "@/pages/admin/CrmInvoicePrint";
import CarrierSite from "@/pages/CarrierSite";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  return (
    <div className="App bg-[#0B0B0B] min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/crm" element={<CrmDashboard />} />
          <Route path="/admin/crm/carriers" element={<CrmCarriers />} />
          <Route path="/admin/crm/carriers/:id" element={<CrmCarrierProfile />} />
          <Route path="/admin/crm/loads" element={<CrmLoads />} />
          <Route path="/admin/crm/loads/carrier/:carrier_id" element={<CrmLoads />} />
          <Route path="/admin/crm/documents" element={<CrmDocuments />} />
          <Route path="/admin/crm/documents/carrier/:carrier_id" element={<CrmDocuments />} />
          <Route path="/admin/crm/followups" element={<CrmFollowups />} />
          <Route path="/admin/crm/followups/carrier/:carrier_id" element={<CrmFollowups />} />
          <Route path="/admin/crm/invoices" element={<CrmInvoices />} />
          <Route path="/admin/crm/invoices/:id/print" element={<CrmInvoicePrint />} />
          <Route path="/sites/:code" element={<CarrierSite />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
